var _module_exports = "<div>\n    Variance\n</div>\n";;
var path = '/builds/observability/imm/signalview/src/legacy/app/analytics/block/VARIANCE/config.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;